import StatusPill from "../../components/ui/StatusPill";
import { adminJobs, adminStats, calendarEvents } from "../../data/siteData";

const tabs = ["Prehled", "Zakazky", "Nabidky", "Faktury", "Klienti", "Kalendar"];

function AdminDashboard({ activeTab, onTabChange, onLogout }) {
  return (
    <section className="page-section">
      <div className="shell">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="eyebrow">Administrace</p>
            <h1 className="mt-3 text-4xl font-extrabold tracking-tight text-white">Sprava ELTT</h1>
            <p className="mt-3 text-sm leading-6 text-slate-300">
              Interni prostredi pro zakazky, klienty, finance a Google Calendar.
            </p>
          </div>
          <button type="button" onClick={onLogout} className="btn-secondary">
            Odhlasit
          </button>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {adminStats.map(([label, value]) => (
            <div key={label} className="card p-5">
              <div className="text-sm font-medium text-slate-400">{label}</div>
              <div className="mt-2 text-3xl font-extrabold text-white">{value}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 overflow-x-auto">
          <div className="flex min-w-max gap-2">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => onTabChange(tab)}
                className={`rounded-md px-3 py-2 text-sm font-semibold ${
                  activeTab === tab ? "bg-cyan-300 text-slate-950" : "bg-cyan-300/5 text-slate-300 hover:bg-cyan-300/10"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-6 grid gap-6 xl:grid-cols-[1fr_360px]">
          <div className="card overflow-hidden">
            <div className="border-b border-cyan-300/10 p-5">
              <h2 className="text-lg font-bold text-white">Zakazky</h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[720px] text-left text-sm">
                <thead className="bg-cyan-300/5 text-xs uppercase tracking-wide text-slate-400">
                  <tr>
                    <th className="px-5 py-3">Zakazka</th>
                    <th className="px-5 py-3">Klient</th>
                    <th className="px-5 py-3">Stav</th>
                    <th className="px-5 py-3">Prubeh</th>
                    <th className="px-5 py-3">Rozpocet</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-cyan-300/10">
                  {adminJobs.map((job) => (
                    <tr key={job.title}>
                      <td className="px-5 py-4 font-medium text-white">{job.title}</td>
                      <td className="px-5 py-4 text-slate-300">{job.client}</td>
                      <td className="px-5 py-4">
                        <StatusPill>{job.status}</StatusPill>
                      </td>
                      <td className="px-5 py-4">
                        <div className="h-2 w-32 rounded-full bg-slate-800">
                          <div className="h-2 rounded-full bg-cyan-300" style={{ width: `${job.progress}%` }} />
                        </div>
                      </td>
                      <td className="px-5 py-4 font-medium text-white">{job.budget}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <aside className="grid gap-6">
            <div className="card p-5">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h2 className="text-lg font-bold text-white">Google Calendar</h2>
                  <p className="mt-1 text-sm text-slate-400">Pouze pro admina.</p>
                </div>
                <button type="button" className="btn-secondary px-3 py-2">
                  Pripojit
                </button>
              </div>
              <div className="mt-5 space-y-3">
                {calendarEvents.map(([time, title, place]) => (
                  <div key={title} className="rounded-md border border-cyan-300/15 bg-[#07131d] p-3">
                    <div className="text-xs font-semibold text-cyan-300">{time}</div>
                    <div className="mt-1 text-sm font-semibold text-white">{title}</div>
                    <div className="text-sm text-slate-400">{place}</div>
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default AdminDashboard;
